module.exports = __webpack_public_path__ + "static/media/LOGO.2924ba94.svg";